var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDatabaseFill = function SvgDatabaseFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "database_fill_svg__a",
    width: 23,
    height: 23,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h23v23H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#database_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M11.518 10.549q3.401 0 5.773-1.053 2.373-1.052 2.373-2.54 0-1.49-2.373-2.542-2.373-1.053-5.773-1.053T5.741 4.414 3.363 6.955t2.378 2.541q2.377 1.053 5.777 1.053m-.009 1.935q1.074 0 2.414-.195 1.34-.194 2.554-.603t2.108-1.043q.894-.634 1.08-1.513v2.617q-.185.879-1.08 1.513t-2.108 1.043q-1.214.41-2.554.603a17 17 0 0 1-2.414.195q-1.074 0-2.414-.195-1.34-.194-2.549-.603T4.442 13.26t-1.079-1.513V9.13q.184.879 1.08 1.513.894.633 2.103 1.043t2.549.603q1.34.195 2.414.195m0 4.552q1.074 0 2.414-.195 1.34-.194 2.554-.603t2.108-1.043q.894-.634 1.08-1.513v2.608q-.185.879-1.08 1.513t-2.108 1.043-2.554.603-2.414.195q-1.074 0-2.414-.195a14.4 14.4 0 0 1-2.549-.603q-1.209-.409-2.104-1.043-.894-.634-1.079-1.513v-2.608q.184.879 1.08 1.513.894.633 2.103 1.043a14.4 14.4 0 0 0 2.549.604q1.34.194 2.414.194"
  }))));
};
export default SvgDatabaseFill;